var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovPerformance = function SvgCovPerformance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173.898,
    height: 108.241,
    viewBox: "0 0 173.898 108.241",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-845.861 -1198.321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.337.934-.006.9.006-.9l5.343.034Z",
    transform: "translate(875.82 1208.124)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.337.934-.006.9.006-.9l5.343.034Z",
    transform: "translate(886.505 1208.193)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.337.934-.006.9.006-.9l5.343.034Z",
    transform: "translate(897.191 1208.262)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.587,1.686-.006.9.006-.9,122.6-.114Z",
    transform: "translate(865.151 1217.131)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.629,1292.524l-1.8-.012.006-.9.6-93.292.9.006,137.161.88-.007.9-.6,81.728-1.8-.013.592-80.828-134.46-.862Z",
    transform: "translate(8.939 0)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.518,1258.509l-36.84-.236a14.058,14.058,0,0,1-12.739-8.283l-3.078-6.772,54.907.354-.012,1.8-52.092-.336,1.914,4.212a12.258,12.258,0,0,0,11.11,7.224l36.84.236Z",
    transform: "translate(0 47.377)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.179,1259.026h-.09l-107.05-.686.012-1.8.9.006,106.15.68h.078a12.278,12.278,0,0,0,11.1-7.078l1.971-4.19-122.5-.786.012-1.8,125.32.8-3.168,6.735a14.053,14.053,0,0,1-12.732,8.115Z",
    transform: "translate(24.68 47.536)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.3,1270.566l-1.8-.012.006-.9a47.65,47.65,0,0,0-47.375-48.007h-.317a47.662,47.662,0,0,0-47.669,47.4l-.006.9-1.8-.012.006-.9a49.447,49.447,0,0,1,49.469-49.185h.329a49.461,49.461,0,0,1,49.163,49.818Z",
    transform: "translate(18.976 22.707)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.852,1252.415l-.3-.85a36.558,36.558,0,0,0-34.3-24.5h-.247a36.507,36.507,0,0,0-25.685,10.544,36.773,36.773,0,0,0-8.779,13.795l-.3.848-1.7-.6.3-.848a38.388,38.388,0,0,1,72.405.172l.3.85Z",
    transform: "translate(25.782 28.422)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.7,1250.084l-1.8-.012.006-.9a8.289,8.289,0,0,0-8.249-8.355h-.055a8.3,8.3,0,0,0-8.3,8.249l-.006.9-1.8-.012.006-.9a10.1,10.1,0,0,1,10.1-10.037h.067a10.089,10.089,0,0,1,10.037,10.166Z",
    transform: "translate(39.194 42.935)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.008,7.767-1.273,6.486,6.586-1.273,7.851.008Z",
    transform: "translate(940.784 1277.681)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.894,5.869l-1.8-.012L-.862-.906l1.8.012Z",
    transform: "translate(933.014 1254.582)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.008,4.76-1.273,3.479,3.54-1.273,4.8.008Z",
    transform: "translate(955.935 1265.725)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.479,4.805-1.273-.008.008-1.273,4.76,3.541Z",
    transform: "translate(906.483 1265.385)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.008,4.76-1.273,3.479,3.54-1.273,4.8.008Z",
    transform: "translate(955.935 1265.725)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.008,4.76-1.273,3.479,3.54-1.273,4.8.008Z",
    transform: "translate(955.935 1265.725)",
    fill: "#5680e9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovPerformance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-performance.e06811fe.svg";
export { ForwardRef as ReactComponent };